import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleVsCompetitors } from '@/mocks/articles';

export default function VsCompetitorsPage() {
  return <ArticleLayout article={articleVsCompetitors} />;
}